import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import noteReducer from "./noteReducer";

export default combineReducers({
  auth,
  message,
  note: noteReducer,

});
